import { useEffect } from "react";
import { BrowserRouter, useNavigate } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { supabase } from "@/lib/supabaseClient";

function AuthListener() {
  const navigate = useNavigate();

  useEffect(() => {
    // Handle token refresh errors (e.g. Supabase project paused / network down)
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const msg = event?.reason?.message || '';
      if (msg.includes('Failed to fetch') || msg.includes('NetworkError')) {
        // Swallow the error silently — Supabase will retry automatically
        event.preventDefault();
      }
    };
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        const isAdminPath = window.location.pathname.startsWith('/admin');
        const isSaPath = window.location.pathname.startsWith('/sa');

        if (!session && (isAdminPath || isSaPath)) {
          navigate('/login', { replace: true });
        }
      }
    );

    return () => {
      subscription.unsubscribe();
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, [navigate]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthListener />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;